export default __webpack_public_path__ + "static/media/codebeat.0b5e2673.svg";